import equalHeight from "../../equalHeight";
import moveToolsListTablet from "./moveToolsListTablet";
import viewModeMobileHandler from "./viewModeMobileHandler";
import dropOrientation from "./dropOrientation";
import noAnimationResize from "./noAnimationResize";

export default function windowResize() {
  $(window).resize(function (e) {
    var windowHeight = window.outerHeight;
    if ($("input").is(":focus")) {
      return;
    }

    if (window.innerWidth < 1023) {
      $('body').removeClass('basket-opened');
    }

    viewModeMobileHandler();
    moveToolsListTablet();
    dropOrientation();

    if (window.innerWidth <= 767) {
      $('#sidebar').appendTo('.mobile-filter-block');
      $('.ctrl-container.search-panel').prependTo('.drop-container');
    } else {
      $('#sidebar').prependTo('#twocolumns');
      if ($('#sidebar .ctrl-container.search-panel').length) {
        $('.ctrl-container.search-panel').insertAfter('.tab-panel');
      }
    }

    $('.info-gallery:visible').each(function (index, el) {
      var $el = $(el);
      equalHeight($el.find('.product_item-img:visible'));
      equalHeight($el.find('.title:visible'));
    });

    noAnimationResize();

    equalHeight('.grid-view .product-list-holder .product_item-img:visible');
    equalHeight('.grid-view .product-list-holder .title:visible');

    // remove #main-navigation custom height
    if (window.innerWidth > 1024) {
      $('#main-navigation').removeAttr('style');
      $("#main-navigation").find('.is-open').removeClass("is-open");
      $('.menu-container').removeClass("is-drop-active");
      $('.category-name').text('Menu');
      $('#wrapper').removeAttr('style');
      $('body').removeClass('menu-active');
      $('menu-btn').removeClass('active');
    }
  });
}